import { Alert, Stack } from "@mui/material";

// 一覧フェッチ失敗時の共通エラー表示。
export function FetchErrorAlert() {
  return (
    <Stack p={4}>
      <Alert severity="error">読み込みに失敗しました。再度お試しください。</Alert>
    </Stack>
  );
}
